import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { deleteAccountWorkTypeAsync, getAccountWorkTypeByAccountWorkTypeIdAsync, checkedState, unCheckedState, updateAccountWorkTypeAsync,updateSorting } from './worktypeSlice';
import clsx from 'clsx';
import { ShowToast } from '../../../common/Toastr';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { setItemStatus, getValueFromResource } from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';
const WorkTypeItem = (props: any) => {
    const { modelRef, worktypeDetail, IsEdit, IsDelete, t, onopenModal } = props;

    const { worktypeList, sortOrder, sortColumn,pageSize  } = useAppSelector((state) => state.worktype);
    const dispatch = useAppDispatch();

    const onDeleteClick = (AccountWorkTypeId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountWorkTypeAsync(AccountWorkTypeId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Work Type Deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");

                        })
                        .catch((rejectedValueOrSerializedError) => {
                            //ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }

    const onEditClick = (AccountWorkTypeId: number) => {
        dispatch(getAccountWorkTypeByAccountWorkTypeIdAsync(AccountWorkTypeId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {
                //console.log('getAccountRoleByAccountRoleIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const handleIsDisabledChange = (e: any, AccountWorkType: any) => {
        const { checked } = e.target;
        const foundIndex = worktypeList.findIndex((item: any) => item.AccountWorkTypeId === AccountWorkType.AccountWorkTypeId);
        if (foundIndex !== -1) {
            const foundItem = worktypeList[foundIndex];
            console.log(foundItem);
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            updatedItem.IsDeleted = false;

            const modifiedList = [...worktypeList.slice(0, foundIndex), updatedItem, ...worktypeList.slice(foundIndex + 1)];
            dispatch(updateAccountWorkTypeAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("WorkType Update Successfully", 'Success', "success", "toast-top-right");

                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");

                })
        }
    }
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }
    return (
        <tr>
            <td>
                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(worktypeDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                    {worktypeDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                </span>
            </td>
            <td><span className="d-block">{worktypeDetail.SortOrder}</span></td>
            <td><span className="d-block">{worktypeDetail.AccountWorkTypeCode}</span></td>
            <td className='text-gray-800  text-hover-primary custom-pointer-cursor '
                onClick={IsEdit ? () => onEditClick(worktypeDetail.AccountWorkTypeId) : undefined}
            >
                <span className="d-block">{worktypeDetail.AccountWorkType}</span>
            </td>
           {/* {IsEdit &&
                <td className='text-center'>
                    <div className="form-check form-switch form-check-custom">
                        <input
                            type="checkbox"
                            className="form-check-input custom-padding-right h-15px w-30px"
                            id="IsDisabled"
                            checked={worktypeDetail.IsDisabled === 'Yes' ? true : false}
                            onChange={(e) => { handleIsDisabledChange(e, worktypeDetail) }}
                        />
                        
                    </div>
                </td>
            } */}
            <td className='text-center'>
                <Dropdown
                    style={{ marginLeft: 1 }}
                    className={clsx('cursor-pointer symbol')}
                    data-kt-menu-attach='parent'
                    data-kt-menu-placement='bottom-end'
                >
                    <Dropdown.Toggle
                        variant="transparent"
                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                        data-tooltip-id="tooltip-Description"
                        data-tooltip-content=
                        // {t("More")}
                        {getValueFromResource('More',dispatch, t)}                      
                          data-tooltip-place="top"
                    >
                        <i className="bi bi-three-dots fs-7"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                        {IsEdit &&
                            <>
                                <div className='menu-hover-bg-sec'>
                                    <Dropdown.Item
                                        className="menu-item me-lg-0 "
                                        onClick={() => {
                                            dispatch(getAccountWorkTypeByAccountWorkTypeIdAsync(worktypeDetail.AccountWorkTypeId))
                                                .unwrap()
                                                .then((originalPromiseResult) => {

                                                    onopenModal();
                                                })
                                                .catch((rejectedValueOrSerializedError) => {
                                                    console.log('getAccountRoleByAccountRoleIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                                                })
                                        }}
                                    >
                                        <span className="menu-icon custom-menu">
                                            <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                        <span className="menu-title custom-menu-fontsize">
                                            {/* {`${t('Edit')}`} */}
                                            {getValueFromResource('Edit',dispatch, t)}
                                            </span>
                                    </Dropdown.Item>
                                </div>
                            </>
                        }
                        {IsDelete && IsEdit && (worktypeDetail.SystemWorkTypeId === null || worktypeDetail.SystemWorkTypeId === 0) &&
                            <div className='separator mb-1 mt-1 opacity-75 '></div>
                        }
                        {/* {IsDelete && */}
                        {IsDelete === true && (worktypeDetail.SystemWorkTypeId === null || worktypeDetail.SystemWorkTypeId === 0) &&
                            <>
                                <div className='menu-hover-bg-danger'>
                                    <Dropdown.Item
                                        className="menu-item me-lg-0 "
                                        onClick={() => { onDeleteClick(worktypeDetail.AccountWorkTypeId) }}>
                                        <span className="menu-icon  custom-menu">
                                            <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                        </span>
                                        <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                            {/* {`${t('Delete')}`} */}
                                            {getValueFromResource('Delete',dispatch, t)}
                                            </span>
                                    </Dropdown.Item>
                                </div>
                            </>
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
        </tr>
    )
}

export default WorkTypeItem;